import React, { useEffect, useRef, useState } from 'react';
import indiaJoyTitle from '../../Assets/images/title.png';
import xLogo from '../../Assets/images/xLogo.png';
import linkLogo from '../../Assets/images/linkd.png';
import instaLogo from '../../Assets/images/insta.png';
import metaLogo from '../../Assets/images/meta.png';
import youtubeLogo from '../../Assets/images/youtube.png';
import Arrow from '../../Assets/images/arrow.png';
import Popup from './popup';

export const Banner = () => {
  const iframeRef = useRef('');

  useEffect(() => {
    // Function to play the video
    const playVideo = () => {
      if (iframeRef.current) {
        iframeRef.current.src = 'https://www.youtube.com/embed/ARYjTbP15Aw?autoplay=1&mute=1';
      }
    };

    // Call playVideo() when component mounts or refreshes
    playVideo();

    // Clean up function to reset src when component unmounts
    // return () => {
    //   if (iframeRef.current) {
    //     iframeRef.current.src = '';
    //   }
    // };
  }, []);

  const [popupOpen, setPopupOpen] = useState(false);

  const onOpenModal = () => {
    setPopupOpen(true);
  };

  const onCloseModal = () => {
    setPopupOpen(false);
  };

  return (
    <div className='indiaJoy__banner__container'>
      <div className='indiaJoy__banner__section'>
        <div className='video-overlay'></div>

        <iframe
          ref={iframeRef}
          className='indiaJoy__bannerInfo'
          title="INDIAJOY"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          autoFocus
        />

        <div className='indiaJoy__banner__detailsSection'>
          <div className='indiaJoy__banner__details'>
            <img src={indiaJoyTitle} alt='indiaJoyTitle' data-aos="fade-right" data-aos-delay="100"/>
            <p className='indiaJoy__banner__content' data-aos="fade-left" data-aos-delay="200">Asia’s premier Media and Entertainment <br />Congregation</p>
            <p className='indiaJoy__banner__subText' data-aos="fade-left" data-aos-delay="300"><span>13 - 17</span>November</p>
            <p className='indiaJoy__banner__text' data-aos="fade-left" data-aos-delay="300">HICC, Novotel, Hyderabad</p>
            <button className='indiaJoy__banner__btn' data-aos="fade-left" data-aos-delay="400">Book Now</button>
          </div>
          <div className='indiaJoy__play__btn' onClick={onOpenModal}>
            Play <img src={Arrow} alt='Arrow' />
          </div>
          <Popup open={popupOpen} onClose={onCloseModal} />
        </div>

        <div className='indiaJoy__rightPanel__container'>
          <div className='indiaJoy__rightPanel'>
            <div className='indiaJoy__rightPanel__section' data-aos="fade-left" data-aos-delay="100">
              <a href="https://twitter.com/indiajoyin?lang=en" target="_blank" rel="noopener noreferrer">
                <img src={xLogo} alt='xLogo' style={{position:'relative',right:'7px'}}/>
              </a>
            </div>
            <div className='indiaJoy__rightPanel__section' data-aos="fade-left" data-aos-delay="200">
              <a href="https://www.linkedin.com/company/indiajoy/" target="_blank" rel="noopener noreferrer">
                <img src={linkLogo} alt='linkLogo' />
              </a>
            </div>
            <div className='indiaJoy__rightPanel__section' data-aos="fade-left" data-aos-delay="300">
              <a href="https://www.instagram.com/indiajoyfestival/" target="_blank" rel="noopener noreferrer">
                <img src={instaLogo} alt='instaLogo' />
              </a>
            </div>
            <div className='indiaJoy__rightPanel__section' data-aos="fade-left" data-aos-delay="400">
              <a href="https://www.facebook.com/Indiajoy.in/" target="_blank" rel="noopener noreferrer">
                <img src={metaLogo} alt='metaLogo' />
              </a>
            </div>
            <div className='indiaJoy__rightPanel__section' data-aos="fade-left" data-aos-delay="500">
              <a href="https://www.youtube.com/channel/UCe8cEAMgMZbqS2cf8t4_JQg" target="_blank" rel="noopener noreferrer">
                <img src={youtubeLogo} alt='youtubeLogo' />
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
